import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import routes from './pages/index';

function App(): JSX.Element {
  const location = useLocation();

  useEffect(() => {
    // Fix Bootstrap modal not auto dismiss when changing page
    const backdrop = document.getElementsByClassName('modal-backdrop');
    for (let i = 0; i < backdrop?.length; i += 1) backdrop[i].remove();
  }, [location.pathname]);

  return (
    <Routes>
      {routes.map((data, index) => (
        <Route key={index} element={data.component} path={data.path} />
      ))}
    </Routes>
  );
}

export default App;
